(() => {
  const MASSAGER_VARIANT_ID = 53538842935637;
  const OIL_VARIANT_ID = 53755709489493;

  let isSyncing = false;
  let needsResync = false;
  let debounceTimer = null;

  function getDrawer() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer')
    );
  }

  function getSectionIds() {
    const drawer = getDrawer();

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(section => section.id);
      } catch (e) {}
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Could not load cart');
    }

    return res.json();
  }

  function getVariantQty(cart, variantId) {
    return cart.items
      .filter(item => Number(item.variant_id) === Number(variantId))
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function getGiftOilLines(cart) {
    return cart.items.filter(item =>
      Number(item.variant_id) === Number(OIL_VARIANT_ID) &&
      item.properties &&
      item.properties._auto_gift === 'true'
    );
  }

  async function renderDrawer(responsePayload) {
    const drawer = getDrawer();

    if (
      drawer &&
      typeof drawer.renderContents === 'function' &&
      responsePayload &&
      responsePayload.sections
    ) {
      drawer.renderContents(responsePayload);
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
  }

  async function addGiftOil(quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: OIL_VARIANT_ID,
            quantity,
            properties: {
              _auto_gift: 'true',
              _gift_label: 'Complimentary massage oil'
            }
          }
        ],
        sections: getSectionIds().join(','),
        sections_url: window.location.pathname
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Could not add gift oil: ${text}`);
    }

    return res.json();
  }

  async function changeLine(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        sections: getSectionIds().join(','),
        sections_url: window.location.pathname
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Could not change gift line: ${text}`);
    }

    return res.json();
  }

  async function syncGiftOil() {
    if (isSyncing) {
      needsResync = true;
      return;
    }

    isSyncing = true;

    try {
      const cart = await getCart();

      const massagerQty = getVariantQty(cart, MASSAGER_VARIANT_ID);
      const giftOilLines = getGiftOilLines(cart);
      const giftOilQty = giftOilLines.reduce((sum, line) => sum + line.quantity, 0);

      let response = null;

      if (massagerQty === 0 && giftOilLines.length > 0) {
        for (const line of giftOilLines) {
          response = await changeLine(line.key, 0);
        }
      } else if (massagerQty > 0 && giftOilLines.length === 0) {
        response = await addGiftOil(massagerQty);
      } else if (giftOilLines.length === 1 && giftOilQty !== massagerQty) {
        response = await changeLine(giftOilLines[0].key, massagerQty);
      } else if (giftOilLines.length > 1) {
        for (const line of giftOilLines) {
          await changeLine(line.key, 0);
        }
        if (massagerQty > 0) {
          response = await addGiftOil(massagerQty);
        }
      }

      if (response) {
  setTimeout(async () => {
    await renderDrawer(response);
  }, 120);
}
    } catch (error) {
      console.error('[KLYFT Gift]', error);
    } finally {
      isSyncing = false;

      if (needsResync) {
        needsResync = false;
        setTimeout(syncGiftOil, 60);
      }
    }
  }

  function scheduleSync(delay = 180) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncGiftOil, delay);
  }

  function isCartRequest(url) {
    if (!url) return false;

    return (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );
  }

  function interceptFetch() {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const url =
          typeof args[0] === 'string'
            ? args[0]
            : args[0] && args[0].url
              ? args[0].url
              : '';

        if (isCartRequest(url)) {
          scheduleSync(700);
        }
      } catch (e) {
        console.error('[KLYFT Gift] fetch intercept error', e);
      }

      return response;
    };
  }

  function interceptXHR() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._klyftCartUrl = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (body) {
      this.addEventListener('load', () => {
        try {
          if (isCartRequest(this._klyftCartUrl || '')) {
            scheduleSync(700);
          }
        } catch (e) {
          console.error('[KLYFT Gift] xhr intercept error', e);
        }
      });

      return originalSend.call(this, body);
    };
  }

  function init() {
    interceptFetch();
    interceptXHR();
    syncGiftOil();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();